import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { get as _get, isEqual as _isEqual } from 'lodash';
import { connect } from "react-redux";
import Helmet from "react-helmet";

import { SingleDropzone, showAlertMessage, Select } from "../../resusableComponents/common/formElements";

import { withRouter } from "../../resusableComponents/hoc/withRouter";
import EnrichDataSources from "../../resusableComponents/common/dataSearchTable/components/EnrichDataSources";

import { getDataSources, getSavedSearchRecords } from "../../redux/services/enrich";
import { getSavedSearchList } from "../../redux/services/history";

import { updatePageLevelLoadingState } from "../../redux/actions/application";

class Enrich extends Component {

  constructor(props) {
    super(props);

    this.defaultSavedSearch = { id: null, search_name: "Select saved search" };

    this.defaultState = {
      activeRequestCount: 0,
      selectedSavedSearchId: { ...this.defaultSavedSearch },

      // States for file uploadation
      savedSearchId: null,
      fileUploaded: false,
      uploadedFileName: "",
      uploadedFileURL: "",
      defaultCheckedDataFields: [], //TODO: Show this as auto-select
      totalSearchRecords: 0
    }

    this.state = {
      ...this.defaultState,
      saveSearchList: [],
      dataSourceList: [],
    };
  }

  componentDidMount() {
    this._fetchSaveSearchList();
    this._fetchDataSource();
  }

  componentDidUpdate(prevProps, prevState) {

    if (!_isEqual(prevState.selectedSavedSearchId, this.state.selectedSavedSearchId)) {
      if (_get(this.state, "selectedSavedSearchId.id", null) === null) {
        this.setState({ totalSearchRecords: 0 });
      } else {
        this._fetchSavedSearchRecords();
      }
    }
  }

  _incrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = (_get(prevState, "activeRequestCount", 0) + 1);
      if (nextCount === 1 && typeof updatePageLevelLoadingState === "function") { updatePageLevelLoadingState(true); }
      return { activeRequestCount: nextCount };
    });
  }

  _decrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = Math.max(0, _get(prevState, "activeRequestCount", 0) - 1);
      if (nextCount === 0 && typeof updatePageLevelLoadingState === "function") { updatePageLevelLoadingState(false); }
      return { activeRequestCount: nextCount };
    });
  }

  _fetchSavedSearchRecords = async () => {
    const { selectedSavedSearchId } = this.state;

    const searchId = (selectedSavedSearchId.id || null);
    if (!searchId) {
      showAlertMessage("Search id is missing, Please refresh the page and try again.");
      return false;
    }

    try {
      this._incrementLoader();

      const response = await getSavedSearchRecords({ search_id: (selectedSavedSearchId.id || null) });

      if (_get(response, "flag", false) === true) {

        this.setState({ totalSearchRecords: _get(response, "data.total_records", 0) });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while fetching saved search total records."));
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching saved search total records."));

    } finally {
      this._decrementLoader();
    }
  }

  _fetchSaveSearchList = async () => {

    try {
      this._incrementLoader();

      const response = await getSavedSearchList({ user_ids: null });

      if ((response.flag || false) === true) {
        let searchList = _get(response, "data", []);
        (searchList || []).unshift(this.defaultSavedSearch);

        this.setState({ saveSearchList: searchList, selectedSavedSearchId: { ...this.defaultSavedSearch } });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while fetching saved search list."));
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching saved search list."));

    } finally {
      this._decrementLoader();
    }
  }

  _fetchDataSource = async () => {
    try {
      this._incrementLoader();

      const response = await getDataSources();

      if ((response.flag || false) === true) {
        this.setState({ dataSourceList: _get(response, "data.data_source", []) });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while fetching data sources details."));
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching data sources details."));

    } finally {
      this._decrementLoader();
    }
  }

  _handleReset = () => {
    this.setState({ ...this.defaultState });
  }

  render() {
    const { allowedDataUploadFiles, allowedDataUploadFilesLabel, intl } = this.props;
    const { fileUploaded, uploadedFileName, uploadedFileURL, saveSearchList, selectedSavedSearchId, dataSourceList, savedSearchId, defaultCheckedDataFields, totalSearchRecords } = this.state;

    return (
      <>
        <Helmet>
          <title>
            {intl.formatMessage({ id: "olympus.enrich", defaultMessage: "Enrich: Olympus" })}
          </title>
        </Helmet>

        <div className="content-wrapper">
          <div className="container-fluid flex-grow-1 px-6 py-6">
            <div className="row gy-2">
              <div className="col-lg-12">
                <h1 className="heading-04 fw-semibold text-dark-35 text-uppercase">
                  <FormattedMessage id="enrich.title" defaultMessage="enrich" />
                </h1>
              </div>
            </div>

            <div className="row gy-4 mt-0">
              <div className="col-lg-12">
                <div className="card shadow-none">
                  <div className="card-body">
                    <h6 className="heading-04 fw-semibold mb-6 text-capitalize">
                      <FormattedMessage id="enrich.select_your_data" defaultMessage="Select Your Data" />
                    </h6>
                    <div className="row gy-4">
                      <div className={`col-lg-6 disabled-section ${(_get(selectedSavedSearchId, "id", null) !== null) ? 'is-disabled' : ''}`}>
                        {(!fileUploaded) && (
                          <label className="form-label text-capitalize">
                            <FormattedMessage id="file.attach_file" defaultMessage="attach file" />
                          </label>
                        )}

                        <SingleDropzone
                          acceptedFormat={allowedDataUploadFiles}
                          allowedExtensions={allowedDataUploadFilesLabel}
                          setState={(args) => this.setState(args)}
                          source="enrich_file"
                          displayUploadedFiles={true}
                          displayUploadedRemoveBtn={true}
                          uploadedFileName={(uploadedFileName || "")}
                          uploadedFileURL={(uploadedFileURL || "")}
                          disabled={_get(selectedSavedSearchId, "id", null) !== null}
                        />
                      </div>
                      <div className="col-lg-6">
                        <div>
                          <label className="form-label text-capitalize">
                            <FormattedMessage id="enrich.saved_data" defaultMessage="saved data" />
                          </label>
                          <Select
                            options={(saveSearchList || [])}
                            getOptionLabel={(option) => (option.search_name || "")}
                            getOptionValue={(option) => (option.id || null)}
                            placeholder={intl.formatMessage({ id: "placeholder.select_field", defaultMessage: "Select {field}" },
                              { field: intl.formatMessage({ id: "history.label.saved_search", defaultMessage: "Saved Search" }) })}
                            value={(selectedSavedSearchId || null)}
                            onChange={(value) => this.setState((prevState) => ({ selectedSavedSearchId: value }))}
                            isMulti={false}
                            isDisabled={(fileUploaded || false)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <EnrichDataSources
              selectedSavedSearchId={selectedSavedSearchId || {}}
              dataSourceList={(dataSourceList || [])}
              resetParentProps={() => this._handleReset()}
              savedSearchId={(savedSearchId || null)}
              fileUploaded={(fileUploaded || false)}
              uploadedFileName={(uploadedFileName || "")}
              uploadedFileURL={(uploadedFileURL || "")}
              defaultCheckedDataFields={(defaultCheckedDataFields || [])}
              source="enrich"
              totalRecords={(totalSearchRecords || 0)}
            />
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  allowedDataUploadFiles: _get(state, "application.constants.allowedDataUploadFiles", ""),
  allowedDataUploadFilesLabel: _get(state, "application.constants.allowedDataUploadFilesLabel", ""),
});

const mapDispatchToProps = (dispatch) => ({
  updatePageLevelLoadingState: (data) => dispatch(updatePageLevelLoadingState(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(Enrich)));
